import { useForm } from "react-hook-form";
import { AnswerInput } from "../AnswerInput";
import { MultipleAnswerInput } from "../MultipleAnswerInput";
import { useEffect, useRef } from "react";
import { getStep5Data } from "../../helper";
import { Chip } from "../Chip";
import { TargetCard } from "../TargetCard";
import { CollapsibleCard } from "../Accordian";

export const Step5 = ({
  questions = [],
  answers = {},
  updateAnswer,
  warmapQuestionResponse = {},
}) => {
  const step5Data = getStep5Data(warmapQuestionResponse);

  const defaultValues = questions.reduce((acc, question) => {
    if (!question.allow_multiple_answers) {
      acc[String(question.id)] =
        answers[question.id] || question?.answer?.answer_text || "";
    }
    return acc;
  }, {});

  const { control, setValue } = useForm({
    defaultValues,
  });

  const prevAnswersRef = useRef(answers);

  useEffect(() => {
    questions.forEach((question) => {
      if (!question.allow_multiple_answers) {
        const questionId = String(question.id);
        const currentAnswer = answers[question.id];
        const prevAnswer = prevAnswersRef.current[question.id];

        if (currentAnswer !== prevAnswer && currentAnswer !== undefined) {
          setValue(questionId, currentAnswer, { shouldDirty: false });
        }
      }
    });

    prevAnswersRef.current = { ...answers };
  }, [answers, questions, setValue]);

  const wp = step5Data.warmupPeriod;

  return (
    <div className="d-flex flex-column w-full" style={{ gap: "24px" }}>
      {wp?.assigned_month_label && wp?.assigned_quarter_label && (
        <div
          className="text-center w-full"
          style={{ color: "#8798A7", fontSize: "14px", lineHeight: 1.4 }}
        >
          This warm-up is anchored to{" "}
          <span style={{ color: "#C8CED3" }}>{wp.assigned_month_label}</span>
          {" · "}
          <span style={{ color: "#C8CED3" }}>{wp.assigned_quarter_label}</span>
          {wp.week_start_date && wp.week_end_date && (
            <>
              {" "}
              (week {wp.week_start_date} → {wp.week_end_date})
            </>
          )}
        </div>
      )}
      <div className="d-flex flex-row justify-content-center align-items-center w-full gap-3">
        <Chip
          label="Goals and Targets"
          content={`${step5Data.totalAchieved} / ${step5Data.chipTotal ?? step5Data.totalGoals}`}
        />
      </div>

      <div>
        <CollapsibleCard title="My Goals and Targets" defaultOpen={true}>
          <TargetCard targets={step5Data.targets} />
        </CollapsibleCard>
      </div>
      {questions?.length > 0 &&
        questions.map((question) => {
          if (question.allow_multiple_answers) {
            return (
              <MultipleAnswerInput
                key={question.id}
                questionId={question.id}
                label={question.question_text}
                defaultValue={
                  answers[question.id] || question?.answer?.answer_text || ""
                }
                onValueChange={(value) => {
                  if (updateAnswer) {
                    updateAnswer(question.id, value);
                  }
                }}
              />
            );
          }

          return (
            <AnswerInput
              control={control}
              key={question.id}
              name={String(question.id)}
              label={question.question_text}
              defaultValue={
                answers[question.id] || question?.answer?.answer_text || ""
              }
              onValueChange={(value) => {
                if (updateAnswer) {
                  updateAnswer(question.id, value);
                }
              }}
            />
          );
        })}
    </div>
  );
};
